<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div>
    <div class="pc" v-if="$store.state.sizeType == 'pc'">
      <div :class="'top top' + type">
        <img src="../assets/home/1logo.png" class="logo" @click="$router.push({ path: 'index'});">
        <div :class="'right type' + $store.state.pageType">
          <div :class="`one ${path === item.path}`" @click="(e) => goPage(e, item)" v-for="(item, index) in navs"
            :key="index">
            {{ item.name }}
            <div class="other" v-if="item.children && item.children.length > 0">
              <div class="erji">
                <div @click="(e) => goPage(e, item2)" v-for="(item2, index2) in item.children" :key="index2">
                  {{ item2.name }}
                  <img v-if="item2.children && item2.children.length > 0" class="no" src="../assets/home/arrow-right-s-fill (1).png">
                  <img v-if="item2.children && item2.children.length > 0" class="yes" src="../assets/home/arrow-right-s-fill.png">

                  <div class="sanji" v-if="item2.children && item2.children.length > 0">
                    <div @click="(e) => goPage(e, item3)" v-for="(item3, index3) in item2.children" :key="index3">
                      {{ item3.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <img @click="change()" v-if="$store.state.pageType==1" class="yuyan2" src="../assets/home/1top_english.png">
        <img @click="change()" v-else class="yuyan2" src="../assets/home/1top_user.png"> -->
          <!-- <img src="/src/assets/home/1top_user.png" alt="个人信息按钮"> -->
        </div>
      </div>
    </div>


    <div class="phone" v-if="$store.state.sizeType == 'phone'">

      <div class="show">
        <img v-if="showAll" @click="closeAll()" src="../assets/home/close.png" class="icon">
        <img v-else @click="openAll()" src="../assets/home/bar-chart-horizontal-line.png" class="icon">
        <img src="../assets/home/1logo.png" class="logo" @click="$router.push({ path: 'index'});">
      </div>

      <div class="hide" v-if="showAll">
        <div :class="`one ${path === item.path}`" @click="(e) => goPage(e, item)" v-for="(item, index) in navs"
          :key="index">
          <div class="label1">{{ item.name }}</div>
          <div class="other" v-if="item.children && item.children.length > 0">
            <div class="erji">
              <div @click="(e) => goPage(e, item2)" v-for="(item2, index2) in item.children" :key="index2">
                <div class="label2">{{ item2.name }}</div>
                <div class="sanji" v-if="item2.children && item2.children.length > 0">
                  <div @click="(e) => goPage(e, item3)" v-for="(item3, index3) in item2.children" :key="index3">
                    <div class="label3">{{ item3.name }} <img src="../assets/home/arrow-right-line.png"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top',
  inject: ['reload'],
  // type:不存在代表背景不透明,存在代表透明
  props: ["type", "path"],
  data() {
    return {
      yingwen: ["index", "about", "product", "media", "contact"],// 存在中英文切换得页面
      navs: [],// 导航栏
      word: "",// 关键字
      showAll: false,// 是否展示手机端顶部全部内容
    };
  },
  methods: {
    // 切换语言
    change: function () {
      if (this.$store.state.pageType == 1) {
        localStorage.setItem("pageType", 2);
      } else {
        localStorage.setItem("pageType", 1);
      }
      if (this.$route.fullPath.indexOf("?chId=") != -1) {
        location.href = location.href.split("?chId=")[0];
      }
      location.reload();
    },
    openAll() {
      this.showAll = true;
    },
    closeAll() {
      this.showAll = false;
    },
    // 进入其他页面
    goPage: function (e, item) {
      e.stopPropagation(); // 阻止冒泡
      this.$router.push({ path: item.path, query: item.other ? { ...item.other } : {} });
    },
  },
  mounted() {
    if (this.$store.state.pageType == 2 && this.yingwen.indexOf(this.$route.name) == -1) {
      this.$router.push({ name: "index" });
    }
    this.navs = this.$language[this.$store.state.pageType].top.navs;
  }
};
</script>

<style scoped lang='scss'>
.top {
  width: 100%;
  height: 0.8rem;
  position: fixed;
  top: 0;
  left: 0;
  background: #00002C;
  padding: 0 calc(50% - 600px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  color: #ffffff;

  .logo {
    width: 120px;
    height: 46px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .right {
    // width: 800px;
    height: 100%;
    display: flex;
    font-size: 0.18rem;
    font-weight: 300;
    align-items: center;
    justify-content: space-between;

    .one {
      width: 144px;
      cursor: pointer;
      height: 100%;
      line-height: 0.8rem;
      text-align: center;
      // margin-right: 50px;

      &.true {
        border-bottom: 2px solid #00D7A0;
        color: #00D7A0;
      }

      .other {
        display: none;
        color: #fff !important;

        .erji {
          position: relative;

          &>div {
            width: 2.6rem;
            height: 0.58rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.3rem;
            background-color: #050535;

            .sanji {
              position: absolute;
              left: 2.6rem;
              top: 0;
              background-color: #050535;
              width: 2.6rem;
              display: none;

              &>div {
                width: 100%;
                height: 0.58rem;
                padding-left: 0.3rem;
                line-height: 0.58rem;
                text-align: left;
                color: #fff;

                &:hover {
                  color: #00D7A0;
                }
              }
            }

            &:hover {
              color: #00D7A0;

              .sanji {
                display: block;
              }

              img {
                &.no {
                  display: none;
                }

                &.yes {
                  display: block;
                }
              }
            }

            img {
              width: 0.06rem;
              height: 0.12rem;

              &.no {
                display: block;
              }

              &.yes {
                display: none;
              }
            }
          }


        }
      }

      &:hover {
        border-bottom: 2px solid #00D7A0;
        color: #00D7A0;

        .other {
          display: block;
        }
      }
    }

    .yuyan {
      height: 26px;
      border-color: #333333;
      color: #333333;
    }

    .yuyan2 {
      cursor: pointer;
      width: 30px;
      height: 30px;
      margin-left: 77px;
    }
  }
}

.phone {

  .show {
    position: fixed;
    top: 0;
    left: 0;
    width: 7.5rem;
    height: 1rem;
    z-index: 9999;
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #00002C;

    .icon {
      width: 0.4rem;
      height: 0.4rem;
    }

    .logo {
      width: 1.2rem;
      height: 0.46rem;
      margin-left: 0.3rem;
    }
  }

  .hide {
    position: fixed;
    top: 1rem;
    left: 0;
    width: 100%;
    height: calc(100% - 1rem);
    z-index: 99999;
    background-color: #000024;
    color: #fff;
    overflow-y: auto;
    padding: 0 0.3rem;

    .one{
      border-bottom: 0.02rem solid #19194C;

      .label1, .label2, .label3{
        padding: 0 0.16rem 0 0.25rem;
      }

      .label1, .label2{
        width: 6.90rem;
        height: 0.99rem;
        line-height: 0.99rem;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 0.32rem;
        color: #FFFFFF;
      }

      .label2{
        color: #FFFFFF;
        opacity: 0.5;
      }

      .label3{
        width: 6.90rem;
        height: 0.56rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 0.24rem;
        color: #FFFFFF;

        img{
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue